import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { useDonorContext } from 'context/donorContext';
import { useTopDonations } from 'hooks/useDonors';

export default function AssignedStaffCard({ handleSelectStaff }) {
  const {
    donor: { user, id: donorId }
  } = useDonorContext();

  const { topDonations, isLoading } = useTopDonations(donorId, 3);

  const topDonationsItems = useMemo(() => {
    if (topDonations) {
      return topDonations.map(item => ({
        id: item.id,
        title: item.package?.package_title || 'N/A',
        value: `£${item.amount}`,
        color: 'text-primary'
      }));
    }
    return [];
  }, [topDonations]);

  const name = useMemo(() => {
    if (user) {
      return `${user.first_name} ${user.last_name}`;
    }
    return '';
  }, [user]);

  return (
    <Card>
      <FalconCardHeader
        title={'Assigned Staff'}
        light={false}
        titleTag="div"
        className="pb-0"
        menuClassName="align-items-start"
        endEl={
          <IconButton
            icon="pen"
            variant="falcon-default"
            className="fs--1 bg-transparent shadow-none p-0"
            onClick={handleSelectStaff}
          />
        }
      />
      <Card.Body>
        <Flex alignItems={'center'}>
          {user ? (
            <>
              <Avatar src={user.image} name={name} size="2xl" />

              <div className="ms-2">
                <p className="mb-0 fw-medium">{name}</p>
              </div>
            </>
          ) : (
            <h5 className="text-500">No Staff Assigned</h5>
          )}
        </Flex>
        <hr />
        <div>
          <Flex justifyContent={'between'}>
            <p className="mb-2 fa--2 fw-medium">Top Donations to date</p>
            <p className="mb-2 fs--2 fw-medium">Amount</p>
          </Flex>
          {isLoading ? (
            <div className="text-center">Loading...</div>
          ) : (
            topDonationsItems.map((item, index) => (
              <div
                key={item.id}
                className={classNames('p-3 border rounded-3 bg-soft-primary', {
                  'mb-3': index !== topDonationsItems.length - 1
                })}
              >
                <Flex justifyContent={'between'} alignItems={'center'}>
                  <p className="mb-0 text-900 fw-medium">
                    <FontAwesomeIcon
                      icon={'circle'}
                      className={classNames('me-2', item.color)}
                    />
                    {item.title}
                  </p>
                  <p className="mb-0 fs--2 text-600 fw-medium">{item.value}</p>
                </Flex>
              </div>
            ))
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

AssignedStaffCard.propTypes = {
  handleSelectStaff: PropTypes.func.isRequired
};
